import { Outlet } from 'react-router-dom'
import { useState, useEffect, Suspense } from 'react'
import Carregando from 'components/Carregando'

export default function TopBackground() {
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1024)

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 1024)
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return (
        <>
            {isSmallScreen && (
                <img
                    alt='Imagem background'
                    src='./img/vector.png'
                    style={{ 
                        width: '100%',
                        position: 'absolute',
                        zIndex: -1, 
                        maxHeight: '100%',
                        top: 0,
                        left: 0
                    }}
                />
            )}
            <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', padding: '48px 0' }}><Carregando /></div>}>
                <Outlet />
            </Suspense>
        </>
    )
}
